import React from "react";
import "../../../Env.css";
// import leftMagnifyIcon from "../../assets/images/DocSearchIcon.png";
import whiteMagnifyIcon from "../../../../../assets/images/white-magnifying-glass.png";

// import SearchFilter from "./SearchFilter";

class SpecManagerSearch extends React.Component {
  constructor(props) {
    super(props);
    const { searchValue } = this.props;
    // console.log("searchValue props", searchValue);
    this.state = {
      searchValue: searchValue || "",
      searchFailed: false,
      previousSearch: "",
      // searchEvent: null,
    };
  }

  handleSearchChange = async (e, buttonClicked) => {
    // this.setState({
    //   isUsingSearch: true
    // })

    // if (!e.target.value) {
    //   console.log("e has no value (SpecManager)")
    //   return
    // }
    // console.log("value for child search: ", e.target.value);
    const { searchValue } = this.state;
    const { handleSearchChange } = this.props;
    let value = "";
    if (!buttonClicked) {
      value = e.target.value;
    } else {
      value = searchValue;
    }
    this.setState({
      searchValue: value.trim() === "" ? "" : value,
      searchFailed: false,
      // isUsingSearch: true,
    });
    if ((buttonClicked || e.key === "Enter" || value === "")) {
      const searchSucceeded = await handleSearchChange(value);
      this.setState({ searchFailed: !searchSucceeded });
      if (searchSucceeded) {
        this.setState({ previousSearch: value });
      }
    }
  }

  render() {
    const { flag } = this.props;
    const { searchValue, searchFailed, previousSearch } = this.state;
    let formControlId = "reportSearchInput";
    if (flag === "templates") {
      formControlId = "reportSearchInput2";
    } else if (flag === "analytics") {
      formControlId = "reportSearchInput3";
    }
    // console.log(searchValue, searchFailed);

    return (
      <div
        className="d-flex align-items-center"
        style={{ height: flag === "reports" || flag === "reports_spec" ? "40px" : "80px" }}
      >
        <div className={flag === "analytics" ? "envSearchFormAnalytics" : "envSearchForm"}>
          <div className="searchBar d-flex align-items-center" style={{ position: "relative" }}>
            <input
              id={formControlId}
              className="envSpecManagerSearchInput"
              placeholder="Search"
              onChange={(event) => {
                this.handleSearchChange(event, false);
              }}
              value={searchFailed ? previousSearch : searchValue}
              onKeyPress={(event) => {
                if (event.key === "Enter") {
                  event.preventDefault();
                  this.handleSearchChange(event, false);
                }
              }}
            />
            <div
              className="envProductSearchBtn2"
              onClick={(event) => {
                this.handleSearchChange(event, true);
              }}
            >
              <img
                src={whiteMagnifyIcon}
                alt="whiteMagnifyIcon"
                style={{
                  width: "13.54px",
                  height: "13.54px",
                  margin: "auto",
                  position: "absolute",
                  left: "8.33%",
                  right: "7.02%",
                  top: "8.33%",
                  bottom: "7.02%",
                }}
              />

            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default SpecManagerSearch;
